import React from 'react';

import { HomePageMenuChildProps, HomePageTopOfPageMenu } from './index';
import { CTARightMenu, RegularLeftMenu } from '../headerMenu';
import useHomePageMenu from '../../../utils/hooks/homePageMenu';
import { DESKTOP_NAV_HEIGHT } from '../../../constants';

type DynamicHomePageMenuProps = HomePageMenuChildProps & {
  onSideMenuToggle: () => void;
  sideMenuToggled: boolean;
};

const DynamicHomePageMenu: React.FC<DynamicHomePageMenuProps> = ({
  menuItems,
  ctaItem,
  secondaryCtaItem,
  hasCtaItems,
  onSideMenuToggle,
  sideMenuToggled,
}: DynamicHomePageMenuProps) => {
  const { navRef, isNavFixed, isNavShadowed } = useHomePageMenu();

  return (
    <div style={{ height: DESKTOP_NAV_HEIGHT }}>
      {isNavFixed && (
        <div
          className="w-full nav-placeholder"
          style={{ height: DESKTOP_NAV_HEIGHT }}
        />
      )}
      <nav
        className={`z-50 bg-white w-full ${isNavFixed ? 'fixed' : 'static'} ${
          isNavShadowed ? 'shadow-sm' : ''
        } transition-shadow`}
        style={{ top: -1 }}
        ref={navRef}
      >
        <div className="container mx-auto">
          <div className="flex justify-between items-center">
            <RegularLeftMenu
              onMenuToggle={onSideMenuToggle}
              toggled={sideMenuToggled}
            />
            {hasCtaItems && (
              <CTARightMenu
                ctaItem={ctaItem}
                secondaryCtaItem={secondaryCtaItem}
              />
            )}
          </div>
        </div>
      </nav>
      <div
        className="relative z-50 container mx-auto flex pointer-events-none"
        style={{ top: -DESKTOP_NAV_HEIGHT }}
      >
        <div
          className="flex items-center bg-white relative pointer-events-auto"
          style={{ height: DESKTOP_NAV_HEIGHT, minWidth: 250 }}
        >
          <HomePageTopOfPageMenu menuItems={menuItems} />
          <div
            id="menu-fade"
            className="absolute left-0 w-full bg-gradient-to-b from-white"
            style={{ height: 60, top: DESKTOP_NAV_HEIGHT }}
          />
        </div>
      </div>
    </div>
  );
};

export default DynamicHomePageMenu;
